import styled, { css } from "styled-components";
import type { TCssUnits } from "app/UtilitiesAndConstants/types/cssTypes";

export const IconContainer = styled.div<{ size: number; units?: TCssUnits }>`
    .SWReactIcons {
        ${({ size, units = "px" }) => {
            const dimension = size + units;

            return css`
                width: ${dimension};
                height: ${dimension};
            `;
        }}
    }
`;
